import { ApplicationIcons } from 'icons/ApplicationIcons';

export const InventoryItemDealerPortalTypeEnumValue = {
  None: 0,
  Walls: 10,
  MerchandisingTooling: 30,
  SignHolder: 40,
  FloorDisplay: 50,
  Apparel: 51,
  Accessories: 60,
  Vehicle: 70,
  MountedDisplay: 80,
  LinQ: 81,
  Xps: 90,
  Helmet: 110,
  MultiPurposeAudio: 120,
  Furniture: 130,
  PartsServices: 140,
  WallPanelComponent: 150,
  Ceiling: 160,

  Display: 300,
  IndividualComponent: 500,
};

export const InventoryItemDealerPortalTypeEnum = [
  {
    value: InventoryItemDealerPortalTypeEnumValue.None,
    name: 'None',
    labelFrench: 'Aucune',
    labelEnglish: 'None',
    shownInNavBar: false,
  },
  {
    value: InventoryItemDealerPortalTypeEnumValue.Walls,
    name: 'Walls',
    labelFrench: 'Panneau Mural',
    labelEnglish: 'Wall Panel',
    //img: '/images/headers/carousel-img-en-03.jpg',
    icon: ApplicationIcons.Walls,
    shownInNavBar: true,
    route: 'walls',
    order: 1,
  },
  {
    value: InventoryItemDealerPortalTypeEnumValue.MerchandisingTooling,
    name: 'MerchandisingTooling',
    labelFrench: 'Outils de marchandisage',
    labelEnglish: 'Merchandising Tooling',
    icon: ApplicationIcons.Tooling,
    shownInNavBar: true,
    route: 'merchandising-toolings',
    order: 3,
  },
  {
    value: InventoryItemDealerPortalTypeEnumValue.SignHolder,
    name: 'SignHolder',
    labelFrench: 'Porte-affiche',
    labelEnglish: 'Sign holders',
    icon: ApplicationIcons.SignHolder,
    parentCategory: InventoryItemDealerPortalTypeEnumValue.IndividualComponent,
    shownInNavBar: true,
    route: 'sign-holder',
    order: 1,
  },
  {
    value: InventoryItemDealerPortalTypeEnumValue.FloorDisplay,
    name: 'FloorDisplay',
    labelFrench: 'Présentoirs de plancher',
    labelEnglish: 'Floor displays',
    icon: ApplicationIcons.FloorDisplay,
    parentCategory: InventoryItemDealerPortalTypeEnumValue.Display,
    shownInNavBar: true,
    route: 'floor-displays',
    order: 1,
  },
  {
    value: InventoryItemDealerPortalTypeEnumValue.Apparel,
    name: 'Apparel',
    labelFrench: 'Vêtement',
    labelEnglish: 'Apparel',
    parentCategory: InventoryItemDealerPortalTypeEnumValue.FloorDisplay,
    icon: ApplicationIcons.FloorDisplay,
    shownInNavBar: true,
    route: 'apparel',
    order: 1,
  },
  {
    value: InventoryItemDealerPortalTypeEnumValue.Accessories,
    name: 'Accessories',
    labelFrench: 'Accessoires',
    labelEnglish: 'Accessories',
    parentCategory: InventoryItemDealerPortalTypeEnumValue.FloorDisplay,
    icon: ApplicationIcons.FloorDisplay,
    shownInNavBar: true,
    route: 'accessories',
    order: 2,
  },
  {
    value: InventoryItemDealerPortalTypeEnumValue.Vehicle,
    name: 'Vehicle',
    labelFrench: 'Véhicule',
    labelEnglish: 'Vehicle',
    parentCategory: InventoryItemDealerPortalTypeEnumValue.FloorDisplay,
    icon: ApplicationIcons.VehiclePurpose,
    shownInNavBar: true,
    route: 'vehicle',
    order: 3,
  },
  {
    value: InventoryItemDealerPortalTypeEnumValue.MountedDisplay,
    name: 'MountedDisplay',
    labelFrench: 'Présentoirs muraux',
    labelEnglish: 'Mounted specialized displays',
    icon: ApplicationIcons.MountedDisplay,
    parentCategory: InventoryItemDealerPortalTypeEnumValue.Display,
    shownInNavBar: true,
    route: 'specialized-display',
    order: 2,
  },
  {
    value: InventoryItemDealerPortalTypeEnumValue.LinQ,
    name: 'LinQ',
    labelFrench: 'LinQ',
    labelEnglish: 'LinQ',
    parentCategory: InventoryItemDealerPortalTypeEnumValue.MountedDisplay,
    icon: ApplicationIcons.MountedDisplay,
    shownInNavBar: true,
    route: 'linq',
    order: 1,
  },
  {
    value: InventoryItemDealerPortalTypeEnumValue.Xps,
    name: 'Xps',
    labelFrench: 'XPS',
    labelEnglish: 'XPS',
    parentCategory: InventoryItemDealerPortalTypeEnumValue.MountedDisplay,
    icon: ApplicationIcons.MountedDisplay,
    shownInNavBar: true,
    route: 'xps',
    order: 2,
  },
  {
    value: InventoryItemDealerPortalTypeEnumValue.Helmet,
    name: 'Helmet',
    labelFrench: 'Casque',
    labelEnglish: 'Helmet',
    parentCategory: InventoryItemDealerPortalTypeEnumValue.MountedDisplay,
    icon: ApplicationIcons.MountedDisplay,
    shownInNavBar: true,
    route: 'helmet',
    order: 3,
  },
  {
    value: InventoryItemDealerPortalTypeEnumValue.MultiPurposeAudio,
    name: 'MultiPurposeAudio',
    labelFrench: 'Présentoir polyvalent et Toit audio',
    labelEnglish: 'Multipurpose and Audio Roof',
    parentCategory: InventoryItemDealerPortalTypeEnumValue.MountedDisplay,
    icon: ApplicationIcons.MountedDisplay,
    shownInNavBar: true,
    route: 'multi-purpose-audio',
    order: 4,
  },
  {
    value: InventoryItemDealerPortalTypeEnumValue.Furniture,
    name: 'Furniture',
    labelFrench: 'Mobilier',
    labelEnglish: 'Furniture',
    icon: ApplicationIcons.Furniture,
    shownInNavBar: true,
    route: 'furniture',
    order: 5,
  },
  {
    value: InventoryItemDealerPortalTypeEnumValue.PartsServices,
    name: 'PartsServices',
    labelFrench: 'Pièces et Service',
    labelEnglish: 'Parts and Service',
    icon: ApplicationIcons.PartsServices,
    shownInNavBar: true,
    route: 'parts-services',
    order: 4,
  },
  {
    value: InventoryItemDealerPortalTypeEnumValue.WallPanelComponent,
    name: 'WallPanelComponent',
    labelFrench: 'Composante de panneau muraux et présentoirs',
    labelEnglish: 'Wall panel and displays components',
    icon: ApplicationIcons.Walls,
    parentCategory: InventoryItemDealerPortalTypeEnumValue.IndividualComponent,
    shownInNavBar: true,
    route: 'wall-panel-display',
    order: 3,
  },
  {
    value: InventoryItemDealerPortalTypeEnumValue.Ceiling,
    name: 'Ceiling',
    labelFrench: 'En-têtes et Enseigne pour plafond suspendu',
    labelEnglish: 'Headers and Ceiling Element Signage',
    icon: ApplicationIcons.Ceiling,
    parentCategory: InventoryItemDealerPortalTypeEnumValue.IndividualComponent,
    shownInNavBar: true,
    route: 'ceilings',
    order: 2,
  },

  {
    value: InventoryItemDealerPortalTypeEnumValue.Display,
    name: 'Display',
    labelFrench: 'Présentoirs',
    labelEnglish: 'Displays',
    icon: ApplicationIcons.Display,
    shownInNavBar: true,
    route: '',
    order: 2,
  },
  {
    value: InventoryItemDealerPortalTypeEnumValue.IndividualComponent,
    name: 'IndividualComponent',
    labelFrench: 'Composantes vendues séparément',
    labelEnglish: 'Individual Components',
    icon: ApplicationIcons.SignHolder,
    shownInNavBar: true,
    route: 'individual-components',
    order: 6,
  },
];

export default InventoryItemDealerPortalTypeEnum;
